import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      HEADER: "Hei, det ser ut som du allerede har en konto.",
      LOGIN_OPTION: "Hvordan ønsker du å logge inn?",
      FORGOT_PASSWORD_TEXT: "Glemt passord?",
      FORGOT_PASSWORD_LINK_TEXT: "Lag nytt",
      EMAIL_IN_USE_BANNER_TEXT: "E-post er allerede i bruk",
      TELEPHONE_IN_USE_BANNER_TEXT: "Telefonnummer er allerede i bruk",
      CLOSE: "Lukk",
    },
    se: {
      HEADER: "Hej, du verkar redan ha ett konto hos oss.",
      LOGIN_OPTION: "Hur vill du logga in?",
      BUTTON_TEXT: "Skicka kod",
      FORGOT_PASSWORD_TEXT: "Glömt ditt lösenord?",
      FORGOT_PASSWORD_LINK_TEXT: "Skapa ett nytt lösenord här",
      EMAIL_IN_USE_BANNER_TEXT: "Email används redan",
      TELEPHONE_IN_USE_BANNER_TEXT: "Telefonnummer används redan",
      CLOSE: "Stäng",
    },
    dk: {
      HEADER: "Hej, du har allerede en konto hos os.",
      LOGIN_OPTION: "Hur vill du logga in?",
      FORGOT_PASSWORD_TEXT: "Glemt dit password?",
      FORGOT_PASSWORD_LINK_TEXT: "Lav et nyt password her",
      EMAIL_IN_USE_BANNER_TEXT: "E-mailadresse allerede i brug",
      TELEPHONE_IN_USE_BANNER_TEXT: "Telefonnummeret er allerede i brug",
      CLOSE: "Luk",
    },
  } as const
)[language];
